module.exports = __webpack_public_path__ + "img/enjoy_banner.3119ff05.png";